import { fundingMethods } from "@/mocks/homepageData";
import { useScrollReveal, getRevealClasses } from "@/hooks/useScrollReveal";

export default function FundingSection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollReveal(0.1);

  return (
    <section ref={sectionRef} className={`py-20 md:py-28 bg-[#111827] ${getRevealClasses(sectionVisible, "up")}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#7C3AED]/40 mb-6">
            <i className="ri-secure-payment-line text-[#7C3AED]"></i>
            <span className="text-sm text-[#F8FAFC]">Payment Methods</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F8FAFC] mb-4">
            Funding &{" "}
            <span className="text-gradient">Withdrawal</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            Multiple payment options with instant deposits and industry-leading withdrawal speeds.
          </p>
        </div>

        {/* Funding Methods Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {fundingMethods.map((method) => (
            <div
              key={method.name}
              className="group bg-[#1F2937] rounded-xl border border-[#374151] p-4 md:p-6 text-center hover:border-[#7C3AED]/50 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Icon */}
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto rounded-xl bg-[#0B0F19] border border-[#374151] flex items-center justify-center mb-3 md:mb-4 group-hover:border-[#7C3AED]/30 transition-colors">
                <i className={`${method.icon} text-xl md:text-2xl text-[#7C3AED]`}></i>
              </div>

              {/* Name */}
              <h3 className="text-xs md:text-sm font-semibold text-[#F8FAFC] mb-2 md:mb-3">{method.name}</h3>

              {/* Badges */}
              <div className="space-y-1.5">
                <div className="inline-flex items-center gap-1 px-1.5 py-1 rounded-md bg-[#10B981]/15 text-[#10B981] text-[10px] md:text-xs font-medium leading-tight">
                  <i className="ri-arrow-down-circle-line flex-shrink-0"></i>
                  <span>{method.badge}</span>
                </div>
                <div className="inline-flex items-center gap-1 px-1.5 py-1 rounded-md bg-[#7C3AED]/15 text-[#7C3AED] text-[10px] md:text-xs font-medium leading-tight">
                  <i className="ri-arrow-up-circle-line flex-shrink-0"></i>
                  <span className="whitespace-normal text-center">↑ {method.withdraw}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="flex items-center gap-4 bg-[#1F2937] rounded-xl p-5 border border-[#374151]">
            <div className="w-12 h-12 rounded-lg bg-[#10B981]/15 flex items-center justify-center flex-shrink-0">
              <i className="ri-money-dollar-circle-line text-xl text-[#10B981]"></i>
            </div>
            <div>
              <div className="text-sm font-semibold text-[#F8FAFC]">Zero Deposit Fees</div>
              <div className="text-xs text-[#94A3B8]">XM covers all transfer costs</div>
            </div>
          </div>
          <div className="flex items-center gap-4 bg-[#1F2937] rounded-xl p-5 border border-[#374151]">
            <div className="w-12 h-12 rounded-lg bg-[#10B981]/15 flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-xl text-[#10B981]"></i>
            </div>
            <div>
              <div className="text-sm font-semibold text-[#F8FAFC]">SSL Secured</div>
              <div className="text-xs text-[#94A3B8]">Bank-grade encryption</div>
            </div>
          </div>
          <div className="flex items-center gap-4 bg-[#1F2937] rounded-xl p-5 border border-[#374151]">
            <div className="w-12 h-12 rounded-lg bg-[#10B981]/15 flex items-center justify-center flex-shrink-0">
              <i className="ri-currency-line text-xl text-[#10B981]"></i>
            </div>
            <div>
              <div className="text-sm font-semibold text-[#F8FAFC]">10+ Currencies</div>
              <div className="text-xs text-[#94A3B8]">USD, EUR, GBP, JPY & more</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}